import clsx from "clsx";
import { ChangeEvent, FC } from "react";
import s from "./styles.module.sass";

interface ITextArea {
	label: string;
	defaultValue?: string;
	value?: string;
	placeholder?: string;
	rows?: number;
	minLength?: number;
	maxLength?: number;
	color?: "primary" | "secondary";
	onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
	name?: string;
	error?: string;
	labelClassName?: string;
}

const TextArea: FC<ITextArea> = ({
	label,
	defaultValue,
	value,
	placeholder,
	rows = 6,
	minLength,
	maxLength,
	color = "primary",
	onChange,
	name,
	error,
	labelClassName,
}) => {
	return (
		<div className={s.textareaWrapper}>
			<label>
				<p className={clsx(s.label, labelClassName)}>{label}</p>
				<textarea
					placeholder={placeholder}
					className={clsx(s.textarea, {
						[s.secondaryColor]: color === "secondary",
						[s.error]: error,
					})}
					rows={rows}
					name={name}
					minLength={minLength}
					maxLength={maxLength}
					defaultValue={defaultValue}
					value={value}
					onChange={onChange}
				/>
			</label>
			{error && (
				<p
					className={clsx(s.errorText, {
						[s.secondaryColor]: color === "secondary",
					})}
				>
					{error}
				</p>
			)}
		</div>
	);
};

export default TextArea;
